import React from 'react'
import { Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import ContentToolbarPage from 'app/components/ContentToolbarPage'

import LargeToolbar from 'app/components/LargeToolbar'
import SearchBar from 'app/components/searchBar/SearchBar'
import FabButton from 'app/components/buttons/FabButton'
import * as R from 'ramda'
import effects from 'app/effects/effects'
import { FormattedMessage, useIntl } from 'react-intl'
import NetworkError from 'app/components/NetworkError'
import { useIsOnline } from 'commons/useIsOnline'
import Assets from 'app/configs/assetConfigs'
import DealsPromotionsTable from './DealsPromotionsTable'
import CreateVoucherDialog from './CreateVoucherDialog'
import { makeStyles } from '@material-ui/styles'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import useVoucherDataDetails from './useVoucherDataDetails'

const useStyles = makeStyles(() => ({
  textEmpty: {
    fontSize: '18px',
    color: '#1673b0',
    fontWeight: 'bold',
    marginTop: '20px',
  },
}))

const styles = (theme) => ({
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
})

export const FILTER_TYPE = {
  ACTIVE_AND_INACTIVE: -1,
  ACTIVE: 1,
  INACTIVE: 0,
}

const DealsPromotions = ({ history }) => {
  const { formatMessage } = useIntl()
  const [isOnline] = useIsOnline()
  const classes = useStyles()

  const [
    onCreateSuccess,
    isOpen,
    initialModel,
    onOpenVoucherFormDialog,
    onCloseVoucherFormDialog,
    handleSetVoucherData,
    search,
    pageInfo,
    refetchData,
    tableFetch,
  ] = useVoucherDataDetails()

  const shouldShowEmptyView = () => {
    return (
      pageInfo.isFirsttimeFetchingNoData &&
      !pageInfo?.data?.length &&
      !pageInfo.isLoading
    )
  }

  const handleClickEditData = (values) => {
    handleSetVoucherData(values)
    onOpenVoucherFormDialog()
  }

  const handleDeleteDeal = (values) =>
    effects.apis.cancelDealsPromotions(values)

  if (!isOnline) {
    return <NetworkError onRetryFetching={() => refetchData()} />
  }

  return (
    <>
      <ContentToolbarPage
        isFitViewPort
        contentToolbar={
          <LargeToolbar
            content={
              <>
                <Typography variant="h6">
                  <FormattedMessage id="dealsPromotions.table.title" />
                </Typography>
              </>
            }
            right={
              <>
                <SearchBar
                  className="ltr:mr-8 rtl:ml-8"
                  searchFor={formatMessage({
                    id: 'dealsPromotions.table.search',
                  })}
                  {...search}
                />
                <FabButton
                  aria-label="Create Voucher"
                  title={formatMessage({
                    id: 'dealsPromotions.attach.select.button.create',
                  })}
                  onClick={onOpenVoucherFormDialog}
                >
                  add
                </FabButton>
              </>
            }
          />
        }
        content={
          <>
            {shouldShowEmptyView() ? (
              <div className="flex flex-col items-center py-64">
                <img
                  src={Assets.dealAndPromotion.errorPermissionIcon}
                  width="300"
                  alt="Error Icon"
                />
                <Typography className={classes.textEmpty}>
                  <FormattedMessage id="dealsPromotion.table.empty" />
                </Typography>
                <PrimaryButton
                  className="mt-10 p-5"
                  onClick={onOpenVoucherFormDialog}
                >
                  <img
                    src={Assets.dealAndPromotion.voucherIcon}
                    width={20}
                    alt="Voucher Icon"
                  />
                  <div className="ltr:ml-4 rtl:mr-4">
                    <FormattedMessage id="createVoucher.dialog.title" />
                  </div>
                </PrimaryButton>
              </div>
            ) : (
              <DealsPromotionsTable
                {...R.mergeRight(tableFetch, {
                  handleClickEditData,
                  handleDeleteOne: handleDeleteDeal,
                })}
              />
            )}
          </>
        }
      />
      <CreateVoucherDialog
        open={isOpen}
        initialModel={initialModel}
        onCreateSuccess={onCreateSuccess}
        onClose={onCloseVoucherFormDialog}
      />
    </>
  )
}

export default withStyles(styles, { withTheme: true })(DealsPromotions)
